module.exports = __WEBPACK_EXTERNAL_MODULE__867__;